import React from "react";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  Box,
  Flex,
  Text,
  Icon,
  Image,
} from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { sideDrawer, activeStyle } from "../../common/constants";
import { FaUser } from "react-icons/fa";
import { useGetUser } from "../../../services/query/account";

const SideDrawer = ({ isOpen, onClose }) => {
  const { data: user } = useGetUser();

  return (
    <>
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bgColor="purpleColor" color="#fff">
          <DrawerCloseButton />

          <DrawerBody p={0}>
            {" "}
            <Box
              h={"100vh"}
              w="100%"
              overflowY="hidden"
              transition="0.3s all ease-in-out"
            >
              <Flex
                flexDirection="column"
                mt="30px"
                borderBottom="2px"
                borderColor="#000"
                pb="15px"
              >
                {user?.user?.Bvn?.image ? (
                  <Image
                    src={`data:image/jpeg;base64,${user?.user?.Bvn?.image}`}
                    width="50px"
                    height="50px"
                    maxW="95px"
                    maxH="100px"
                    borderRadius="50%"
                    mx="auto"
                  />
                ) : (
                  <Icon
                    as={FaUser}
                    width="50px"
                    height="50px"
                    maxW="95px"
                    maxH="100px"
                    borderRadius="50%"
                    mx="auto"
                  />
                )}
                <Text textAlign="center" fontSize="20px" fontWeight="500">
                  {user?.user?.Bvn?.firstName || "welcome"}{" "}
                  {user?.user?.Bvn?.lastName || ""}
                </Text>
              </Flex>

              <Flex
                flexDir={"column"}
                borderBottom="2px"
                borderColor="#000"
                pb="15px"
              >
                {sideDrawer.map((item) => (
                  <Box key={item.path} textAlign={"center"} my={4}>
                    <NavLink
                      to={item.path}
                      key={item.path}
                      onClick={onClose}
                      style={({ isActive }) =>
                        isActive
                          ? { ...activeStyle, fontWeight: "600", color: "#000" }
                          : {
                              ...activeStyle,
                              backgroundColor: "",
                            }
                      }
                    >
                      {item.name}
                    </NavLink>
                  </Box>
                ))}
              </Flex>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default SideDrawer;
